import { PhoneCall, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Button } from "@/components/ui/button";
export default function HeroFrederick() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [{
      "@type": "HomeAndConstructionBusiness",
      "@id": "https://triserveinc.com/#business",
      name: "TriServe",
      telephone: "855-435-6631",
      areaServed: {
        "@type": "AdministrativeArea",
        name: "Frederick County, MD"
      }
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#service-water",
      name: "Water Damage & Flood Restoration",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Frederick County, MD"
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#service-sewage",
      name: "Sewage Backup Cleanup",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Frederick County, MD"
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#service-fire",
      name: "Fire & Smoke Damage Restoration",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Frederick County, MD"
    }, {
      "@type": "Service",
      "@id": "https://triserveinc.com/#service-mold",
      name: "Mold Remediation",
      provider: {
        "@id": "https://triserveinc.com/#business"
      },
      areaServed: "Frederick County, MD"
    }, {
      "@type": "BreadcrumbList",
      "@id": "https://triserveinc.com/#breadcrumb",
      itemListElement: [{
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://triserveinc.com/"
      }, {
        "@type": "ListItem",
        position: 2,
        name: "Maryland",
        item: "https://triserveinc.com/MarylandPage"
      }, {
        "@type": "ListItem",
        position: 3,
        name: "Frederick County"
      }]
    }]
  };
  return <section id="herofrederickcountyrestoration" data-nav="light" className="relative bg-background text-foreground pt-12 pb-16 md:pt-16 md:pb-24 border-b border-border/60">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd)
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="mb-6 md:mb-8">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/">Home</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/MarylandPage">Maryland</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>Frederick County</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        <div className="max-w-3xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.12]">
            Frederick County Restoration Services by TriServe
          </h1>

          <p className="mt-5 text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl">
            24/7 emergency restoration crews dispatched locally throughout
            Frederick County for rapid disaster response and structural recovery.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3.5">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-medium h-12 px-6 shadow-sm">
              <a href="tel:8554356631">
                <PhoneCall className="size-4" />
                <span>Call Now: 855-435-6631</span>
              </a>
            </Button>

            <Button asChild variant="outline" size="lg" className="border-border hover:bg-muted text-foreground font-medium h-12 px-6 shadow-xs">
              <Link to="/ContactRequestServicePage">
                <span>Request Service</span>
                <ArrowRight className="size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}